import { render } from "./PlayList.vue?vue&type=template&id=19aa181a"
const script = {}

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__